import { Component, Inject, LOCALE_ID, Pipe } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { FormatService } from '~/services/administration.ts/format';

@Pipe({
    name: 'costFormat',
    standalone: false
})

export class CostFormatPipe extends DecimalPipe {

  _model: any;

  constructor(@Inject(LOCALE_ID) locale: string,
    private _formatService: FormatService) {
    super(locale);
  }

  transform(val: any, args?: any): any {
    if(!isFinite(val) || val=='')
      val = 0;
    this._model = this._formatService.costFormat;
    return super.transform(val,this._model)
  }
}
